app.service('productRecommendations', function (
	productCardConfig,
	front,
	productCompare,
	lazyLoad,
	sticky, 
	logData,
	log,
	viewPoint
) {
	let config, $self;

	function init() {
		config = productCardConfig.getData();
		if(config.preview) {
			return;
		}
		if(config.recommendationsEnabled){
			showRecommendations();
			setElements();
			setEvents();
		}
	}

	function setElements()  {
		$self = $('#recommended-products-middle');
	}

	function setEvents() {
		$self.on('click', '.js-product-box', function(e){
			const that = $(this);
			logSeeAlsoCarouselClick(that);
		})
	}

	function logSeeAlsoCarouselView() {
		const productsPlu = $self.find('.plu').map((i,plu)=>plu.value).get().join(';');
		logEvent({
			id: 'Rek_view',
			f04: 1,
			f05: productsPlu
		});
	}

	function logSeeAlsoCarouselClick(that) {
		const index = parseInt($(that).index('.js-product-box'));
		const productPlu = $(that).find('.plu').val();
		logEvent({
			id: 'Rek_klik',
			f04: productPlu,
			f05: index
		});
	}

	function logEvent(params) {
		const plu = config.plu;
		const currentUrl = window.location.href;
		const currentPage = front.page();
		const defaults = {
			f03: plu,
			f06: currentUrl,
			f07: currentPage
		};
		const event = $.extend(defaults, params);
		log.event(event);
	}

	function showRecommendations() {
		const $destination = getRecommendationDestination();
		$destination.addClass('loading');

		fetchRecommendations()
			.then(html => {
				$destination.html(html);
				$destination.productSlider();

				updateHeight($destination);

				productCompare.checkCompared();
				lazyLoad.update();
				sticky.rebuild('productUpselling');
				viewPoint.set({
					element: $self,
					height: 0.6*$self.height(),
					callback: function(){
						logSeeAlsoCarouselView();
					}
				})
			})
			.fail(() => {
				$destination.text("Przepraszamy, wystąpił błąd pobierania rekomendacji.");
			})
			.always(() => {
				$destination
					.addClass('loaded')
					.removeClass('loading');
			});
	}

	function fetchRecommendations() {
		const data = {
			productId: config.id,
			newProductCard: true
		}
		let url = '/see-also-carousel.ltr';
		if (logData.showRecommendationsFromGoogleOnProductCard()) {
			url = '/google-user-personalized-see-also-carousel.ltr';
			data.productPlu = config.plu;
			data.userId = logData.customerId();
		} else if (logData.showRecommendationsFromAWSonProductCard()) {
			url = '/user-personalized-see-also-carousel.ltr';
			data.userId = logData.customerId();
		} 
		return $.ajax({
			url: url,
			data: data
		});
	}

	function getRecommendationDestination() {
		if (config.unavailableAtTheMoment || !config.productActive) {
			return $("#recommended-products-top");
		}
		return $('#recommended-products-middle');
	}

	function updateHeight($destination) {
		let $carousel = $destination.find('.see-also-carousel');
		const maxHeight = $carousel.find('ul').height();
		$carousel.css('height', maxHeight + 10);
	}

	return {
		init
	};
});
